export const parseDebug = {
	chooseTabularLog: false,
	columnsConsistencyLog: false,
}